import { defaultValue } from 'components/shared/LandingPage/contexts/LandingPageContext';
import { LANDING_PAGE_TYPES } from 'constants/index';

export function useLandingContext({ landingData, page, links, isPreview, isSample }) {
  return {
    ...defaultValue,
    landingData,
    page,
    links,
    readOnly: true,
    hasHeader: false,
    isPreview,
    isItinerariesItem: isSample || false,
    isCoverPage: landingData?.role === LANDING_PAGE_TYPES.COVER_PAGE,
  };
}
